// @flow

export default {
  READ: 'read',
  SENT: 'sent',
  SENDING: 'sending',
  DELIVERED: 'delivered',
  DELIVERY_ERROR: 'delivery_error',
};
